import React from "react";
import { FormattedMessage } from "react-intl";

import { Checkbox } from "src/common/components/Checkbox";
import { IsLockedContext } from "src/features/forms/context/IsLockedContext";
import { useValue } from "src/features/forms/hooks/useField";
import { CheckboxProps } from "src/features/forms/types";

export const CheckboxRenderer: React.FunctionComponent<CheckboxProps> = ({
	label,
	...directProps
}) => {
	const isLocked = React.useContext(IsLockedContext);
	const [checked, onChangeChecked] = useValue(false);
	return (
		<Checkbox
			{...directProps}
			disabled={isLocked}
			checked={checked}
			onChangeChecked={onChangeChecked}
		>
			{label && <FormattedMessage {...label} />}
		</Checkbox>
	);
};
